const StatsTab = ({ stats }) => {
  if (!stats) return null

  return (
    <div className="space-y-4">
      <h3 className="text-xl font-semibold text-white mb-6">
        Feedback Statistics
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-gradient-to-br from-purple-500/20 to-indigo-500/20 rounded-xl p-6 text-center border border-purple-500/30">
          <div className="text-5xl font-bold text-purple-300 mb-2">
            {stats.uniqueFacilitatorCount}
          </div>
          <div className="text-gray-300">
            Unique Facilitators Submitted Feedback
          </div>
        </div>
        <div className="bg-gradient-to-br from-indigo-500/20 to-purple-500/20 rounded-xl p-6 text-center border border-indigo-500/30">
          <div className="text-5xl font-bold text-indigo-300 mb-2">
            {stats.totalSubmissions}
          </div>
          <div className="text-gray-300">
            Total Feedback Submissions
          </div>
        </div>
      </div>
    </div>
  )
}

export default StatsTab
